export default {
  name: "pbxCloud",
  component: () =>
    import(
      /* webpackChunkName: "pbxLayout" */ "@/modules/pbxCloud/layouts/PbxCloudLayout.vue"
    ),
  redirect: "/pbxCloud/chat",
  children: [
    {
      path: "directorio",
      name: "pbxCloud-directorio",
      component: () =>
        import(
          /* webpackChunkName: "directorio" */ "@/modules/pbxCloud/pages/Directorio.vue"
        ),
    },
    {
      path: "contactos",
      name: "pbxCloud-contactos",
      component: () =>
        import(
          /* webpackChunkName: "contactos" */ "@/modules/pbxCloud/pages/Contactos.vue"
        ),
    },
    {
      path: "chat",
      name: "pbxCloud-chat",
      component: () =>
        import(
          /* webpackChunkName: "chat" */ "@/modules/pbxCloud/pages/Chat.vue"
        ),
    },
    {
      path: "agenda",
      name: "pbxCloud-agenda",
      component: () =>
        import(
          /* webpackChunkName: "pbxCloud-agenda" */ "@/modules/crm/pages/Agenda/Agenda.vue"
        ),
    },
    {
      path: "buzon",
      name: "pbxCloud-buzon",
      component: () =>
        import(
          /* webpackChunkName: "buzon" */ "@/modules/pbxCloud/pages/Voicemail.vue"
        ),
    },
    {
      path: "grabaciones",
      name: "pbxCloud-grabaciones",
      component: () =>
        import(
          /* webpackChunkName: "grabaciones" */ "@/modules/pbxCloud/pages/Grabaciones.vue"
        ),
    },
    {
      path: "conferencias",
      name: "pbxCloud-conferencias",
      component: () =>
        import(
          /* webpackChunkName: "conferencias" */ "@/modules/pbxCloud/pages/Conferencias.vue"
        ),
    },
    {
      path: "etiquetas",
      name: "pbxCloud-etiquetas",
      component: () =>
        import(
          /* webpackChunkName: "etiquetas-llamadas" */ "@/modules/reportes/pages/Etiquetas.vue"
        ),
    },
    {
      path: "historial",
      name: "pbxCloud-historial",
      component: () =>
        import(
          /* webpackChunkName: "conferencias" */ "@/modules/pbxCloud/pages/Historial.vue"
        ),
    },
    {
      path: "meetings",
      name: "pbxCloud-meetings",
      component: () =>
        import(
          /* webpackChunkName: "meetings" */ "@/modules/pbxCloud/pages/WebMeetings.vue"
        ),
    },
    {
      path: "drive",
      name: "pbxCloud-drive",
      component: () =>
        import(
          /* webpackChunkName: "drive" */ "@/modules/pbxCloud/pages/Drive.vue"
        ),
    },
  ],
};
